import { ShieldCheck, Clock, Radar, Handshake } from "lucide-react";
import { Reveal, SectionHeader } from "./Shared";
import { IMAGES } from "@/lib/site";

const POINTS = [
  {
    icon: ShieldCheck,
    title: "Syariah-First Screening",
    text: "Every Bursa setup is filtered against SC Malaysia's Syariah-compliant list before it reaches your phone.",
  },
  {
    icon: Radar,
    title: "10,000+ Hours of Desk Research",
    text: "Technical and fundamental confluence across Bursa, Comex, SGX and US markets — no recycled calls.",
  },
  {
    icon: Clock,
    title: "MYT Desk Support 9AM — 9PM",
    text: "A dedicated relationship manager on Malaysian time, fluent in the sessions you actually trade.",
  },
  {
    icon: Handshake,
    title: "VIP Account Handling",
    text: "For RM100K+ portfolios, our senior desk executes and manages positions on your mandate.",
  },
];

export default function WhyUs() {
  return (
    <section id="about" data-testid="about-section" className="border-t border-line bg-surface/40 py-20 md:py-28">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
        <div>
          <SectionHeader
            eyebrow="Why Globex"
            title="Built in the Straits, for Straits traders."
            sub="Globex Sdn Bhd is a research desk operating between Kuala Lumpur and Singapore since 2008. Our only product is conviction — signals with exact entries, stops and targets, sized for RM and SGD capital."
          />
          <div className="mt-10 grid gap-6 sm:grid-cols-2">
            {POINTS.map((p, idx) => (
              <Reveal key={p.title} delay={idx * 0.1}>
                <div data-testid={`why-card-${idx}`} className="h-full rounded-xl border border-line bg-panel p-5 transition-colors duration-300 hover:border-alpha/40">
                  <p.icon size={20} className="text-gold" />
                  <h3 className="mt-3 font-display text-base font-bold text-slate-100">{p.title}</h3>
                  <p className="mt-2 text-xs leading-relaxed text-slate-400">{p.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.2}>
          <div className="relative">
            <div className="absolute -inset-3 rounded-2xl border border-gold/30" aria-hidden="true" />
            <img
              src={IMAGES.desk}
              alt="Globex institutional trading desk"
              loading="lazy"
              className="spotlight-img relative max-h-[70vh] w-full rounded-2xl border border-line object-cover"
            />
            <div className="glow-gold absolute -bottom-6 -left-6 rounded-xl border border-line bg-obsidian px-6 py-4">
              <p className="font-mono text-2xl font-bold text-gold">9,284</p>
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">Active traders MY &amp; SG</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
